<app-form-pyramidal-pyramid-item
  [prefilledName]="prefilledName"
  [prefilledCategoryId]="prefilledCategoryId"
  [prefilledSubCategoryId]="prefilledSubCategoryId"
  [lockNameAndCategories]="false"
  (formValidityChanged)="onFormValidityChanged($event)">
</app-form-pyramidal-pyramid-item>
